import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Simple working solution - creates mailto link
      const emailBody = `
New Contact Form Submission from AlledThermal Website:

Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company || 'Not specified'}
Subject: ${formData.subject}

Message:
${formData.message}

---
Submitted from AlledThermal website contact form.
      `;
      
      const mailtoLink = `mailto:alliedthermaldlf@gmail.com?subject=AlledThermal General Enquiry&body=${encodeURIComponent(emailBody)}`;
      
      // Open email client
      window.open(mailtoLink, '_blank');
      
      // Show success message
      setIsSubmitted(true);
      setAlertType('success');
      setAlertMessage('✅ SUBMITTED SUCCESSFULLY! Email client opened with your message');
      setShowAlert(true);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
      });
      
    } catch (error) {
      console.error('Form Error:', error);
      setAlertType('danger');
      setAlertMessage('❌ Error opening email. Please try WhatsApp or call +91 9312068097');
      setShowAlert(true);
    } finally {
      setIsLoading(false);
      setTimeout(() => setShowAlert(false), 8000);
    }
  };

  if (isSubmitted) {
    return (
      <>
        <div className="page-header">
          <Container>
            <h1>Message Sent!</h1>
            <p>Thank you for contacting AlledThermal</p>
          </Container>
        </div>

        <section className="section-padding">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="text-center">
                <div className="bg-white p-5 rounded shadow-sm">
                  <div style={{ fontSize: '5rem', marginBottom: '2rem', color: '#10b981' }}>✅</div>
                  <h2 className="mb-4" style={{ color: '#10b981' }}>Form Submitted Successfully!</h2>
                  <p className="mb-4" style={{ fontSize: '1.2rem' }}>
                    Your email client has opened with a pre-filled message to <strong>alliedthermaldlf@gmail.com</strong>
                  </p>
                  <div className="mb-4 p-4" style={{ backgroundColor: '#f0f9ff', borderRadius: '12px' }}>
                    <strong>Next Steps:</strong>
                    <ul className="list-unstyled mt-3" style={{ fontSize: '1.1rem' }}>
                      <li className="mb-2">📧 Send the email from your email client</li>
                      <li className="mb-2">👨‍💼 We'll receive it at alliedthermaldlf@gmail.com</li>
                      <li className="mb-2">📞 We'll respond within 24 hours</li>
                    </ul>
                  </div>
                  <div className="mb-4">
                    <p><strong>Need immediate assistance?</strong></p>
                    <Button 
                      href="https://wa.me/919312068097?text=Hello! I just submitted a contact form on AlledThermal website." 
                      target="_blank"
                      className="btn-primary-custom me-3"
                      size="lg"
                    >
                      💬 WhatsApp Now
                    </Button>
                    <Button 
                      href="tel:+919312068097" 
                      variant="outline-primary"
                      size="lg"
                    >
                      📞 Call +91 9312068097
                    </Button>
                  </div>
                  <Button 
                    onClick={() => {
                      setIsSubmitted(false);
                      setShowAlert(false);
                    }}
                    variant="link"
                    style={{ fontSize: '1.1rem' }}
                  >
                    ← Submit Another Message
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }

  return (
    <>
      <div className="page-header">
        <Container>
          <div className="text-center">
            <h1 style={{ 
              fontSize: '3rem',
              fontWeight: '800',
              color: 'white',
              marginBottom: '1rem'
            }}>
              Contact Us
            </h1>
            <p style={{ fontSize: '1.2rem', color: 'rgba(255,255,255,0.9)' }}>
              Get in touch with our thermal engineering experts
            </p>
          </div>
        </Container>
      </div>

      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mb-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <h3 className="mb-4">Send Us a Message</h3>
                <div className="mb-3 p-3" style={{ 
                  backgroundColor: '#f8fafc', 
                  borderRadius: '8px', 
                  border: '1px solid #e2e8f0',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b' }}>
                    📧 Messages sent directly to: <strong>alliedthermaldlf@gmail.com</strong>
                  </div>
                  <div style={{ fontSize: '0.9rem', color: '#64748b', marginTop: '0.5rem' }}>
                    Quick response within 24 hours guaranteed
                  </div>
                </div>
                
                {showAlert && (
                  <Alert variant={alertType} className="mb-4">
                    <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                      {alertMessage}
                    </div>
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Full Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                          placeholder="Enter your full name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Address *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                          placeholder="your.email@example.com"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                          disabled={isLoading}
                          placeholder="Your company name (optional)"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                          type="text"
                          name="subject"
                          value="General Enquiry"
                          disabled
                          style={{ backgroundColor: '#f8f9fa' }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-4">
                    <Form.Label>Message *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                      placeholder="Please describe your inquiry in detail..."
                    />
                  </Form.Group>
                  <Button 
                    type="submit" 
                    className="btn-primary-custom"
                    disabled={isLoading}
                    size="lg"
                  >
                    {isLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Sending to amodhjaiswal@gmail.com...
                      </>
                    ) : (
                      '📤 Send Message'
                    )}
                  </Button>
                </Form>
              </div>
            </Col>
            <Col lg={4}>
              <div className="bg-white p-4 rounded shadow-sm mb-4">
                <h4 style={{ color: '#1e293b', marginBottom: '1.5rem' }}>Contact Information</h4>
                <div className="contact-item" style={{ color: '#1e293b', marginBottom: '1rem' }}>
                  <strong>📍 Address:</strong>
                  <div style={{ marginTop: '0.5rem', lineHeight: '1.5' }}>
                    Block-A, Plot Number-1731, NHPC Rd, Greenfield Colony, Block C, Greenfields Colony Block C, chowk, Faridabad, Haryana 121003
                  </div>
                </div>
                <div className="contact-item" style={{ color: '#1e293b', marginBottom: '1rem' }}>
                  <strong>📞 Phone:</strong> +91 9312068097
                </div>
                <div className="contact-item" style={{ color: '#1e293b', marginBottom: '1rem' }}>
                  <strong>💬 WhatsApp:</strong> 
                  <a href="https://wa.me/919312068097" target="_blank" rel="noopener noreferrer" style={{color: '#25d366', textDecoration: 'none', marginLeft: '0.5rem'}}>
                    +91 9312068097
                  </a>
                </div>
                <div className="contact-item" style={{ color: '#1e293b' }}>
                  <strong>✉️ Email:</strong> alliedthermaldlf@gmail.com
                </div>
              </div>
              
              <div className="bg-white p-4 rounded shadow-sm mb-4">
                <h5 style={{ color: '#1e293b', marginBottom: '1.5rem' }}>Business Hours</h5>
                <div className="contact-item" style={{ color: '#1e293b', marginBottom: '0.8rem' }}>
                  <strong>Monday - Friday:</strong> 8:00 AM - 6:00 PM
                </div>
                <div className="contact-item" style={{ color: '#1e293b', marginBottom: '0.8rem' }}>
                  <strong>Saturday:</strong> 9:00 AM - 4:00 PM
                </div>
                <div className="contact-item" style={{ color: '#1e293b', marginBottom: '0.8rem' }}>
                  <strong>Sunday:</strong> Closed
                </div>
                <div className="contact-item" style={{ color: '#dc2626', fontWeight: '600' }}>
                  <strong>Emergency:</strong> 24/7 Support Available
                </div>
              </div>

              <div className="bg-white p-4 rounded shadow-sm">
                <h5 style={{ color: '#1e293b', marginBottom: '1.5rem' }}>Quick Contact</h5>
                <div className="d-grid gap-2">
                  <Button 
                    href="https://wa.me/919312068097?text=Hello! I need information about Allied Thermal services." 
                    target="_blank"
                    variant="success"
                    size="sm"
                  >
                    💬 WhatsApp Chat
                  </Button>
                  <Button 
                    href="tel:+919312068097" 
                    variant="primary"
                    size="sm"
                  >
                    📞 Call Now
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContactUs;
